import { render, staticRenderFns } from "./Mensajes.vue?vue&type=template&id=3a8add97&scoped=true&"
import script from "./Mensajes.vue?vue&type=script&lang=js&"
export * from "./Mensajes.vue?vue&type=script&lang=js&"
import style0 from "./Mensajes.vue?vue&type=style&index=0&id=3a8add97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8add97",
  null
  
)

export default component.exports